import { Pipe, PipeTransform } from '@angular/core';
import { findByProp } from '../../../utils';

@Pipe({
    name: 'cegekTransformPipe'
})

export class CegekTransformPipe implements PipeTransform {
    transform(ceg_id: any, cegek: any[]): any {
        return findByProp(cegek, 'id', ceg_id)?.megnevezes || '-';
    }
}